<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="300"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <v-btn-toggle
            borderless
            mandatory
            :value="filter"
            @change="filterChecklist($event)"
          >
            <v-btn value="all"> All </v-btn>
            <v-btn value="uncompleted"> Uncompleted </v-btn>
            <v-btn value="completed"> Completed </v-btn>
          </v-btn-toggle>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="menu = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Configuration",
  components: {},
  data: () => ({
    menu: false,
  }),
  computed: {
    ...mapState("configurations", ["filter"])
  },
  methods: {
    ...mapActions("configurations", ["filterChecklist"])
  },
};
</script>

  